import { useState, useEffect } from 'react';
import { useNotificationProvider } from 'hooks';
import {
	getUsersApi,
	getCompanies,
	getContactTypes,
	getLanguageTypes,
} from 'api';
import { mergePhone, addCustName } from 'containers/pages/users/libs';
import { useDispatch, useSelector } from 'react-redux';
import {
	selectAllExistingContacts,
	storeExistingContacts,
} from 'redux/userMgt/userMgtSlice';
import {
	selectSelectedContact,
	storeSearchedUsers,
} from 'redux/userMgt/userMgtSlice';
import { storeUsers } from 'redux/users/usersSlice';
import { storeCompanies } from 'redux/companies/companiesSlice';
import { storeContactTypes } from 'redux/contactTypes/contactTypesSlice';
import { storeRoleGroups } from 'redux/roleGroups/roleGroupsSlice';
import { storeLanguages } from 'redux/contacts/languagesSlice';
import getRoleGroupApi from 'api/users/getRoleGroupApi';
import { storeApps } from 'redux/apps/appsSlice';
import getUserGroupsApi from 'api/getUserGroupsApi';
import getUserInfoApi from 'api/login/getUserInfoApi';
import filterSDSSupport from 'containers/pages/users/libs/filterSDSSupport';

/**
 * @function useUsers
 * @returns {object}
 */
function useUsers() {
	const existingContacts = useSelector(selectAllExistingContacts);
	const selectedContact = useSelector(selectSelectedContact);
	const dispatch = useDispatch();
	const { notifyError } = useNotificationProvider();
	const [isLoading, setIsLoading] = useState(false);
	const [isOpenForm, setIsOpenForm] = useState(false);
	const [isAddMode, setIsAddMode] = useState(true);
	const [selContId, setSelContId] = useState('');
	const [selUserId, setSelUserId] = useState('');
	const [userGroups, setUserGroups] = useState([]);

	const onClickForm = () => {
		if (!isOpenForm) {
			setIsAddMode(true);
		}
		setIsOpenForm(!isOpenForm);
		dispatch(storeExistingContacts([]));
	};

	const handleMode = (mode) => setIsAddMode(mode);

	useEffect(() => {
		(async () => {
			const userId = selectedContact.userId;
			if (userId === '' && userId !== undefined) {
				setSelContId(selectedContact.id);
				setIsAddMode(true);
			} else if (userId !== '' && userId !== undefined) {
				setSelUserId(userId);
				setIsAddMode(false);
			}
		})();
	}, [notifyError, selectedContact]);

	useEffect(() => {
		(async () => {
			setIsLoading(true);
			try {
				const _companies = await getCompanies();
				const _contactTypes = await getContactTypes();
				const _languageTypes = await getLanguageTypes();
				const apps = await getRoleGroupApi();
				const tempUsers = await getUsersApi();
				const merged = await mergePhone(tempUsers);
				const _users = await addCustName(merged, _companies);
				const _userGroups = await getUserGroupsApi();
				const userInfo = await getUserInfoApi();
				const __users = filterSDSSupport(_users, userInfo);
				dispatch(storeCompanies(_companies));
				dispatch(storeContactTypes(_contactTypes));
				dispatch(storeLanguages(_languageTypes));
				dispatch(storeRoleGroups(apps.roleGroups));
				dispatch(storeApps(apps.apps));
				dispatch(storeUsers(__users));
				dispatch(storeSearchedUsers(__users));
				setUserGroups(_userGroups);
			} catch (error) {
				notifyError(error.message);
			} finally {
				setIsLoading(false);
			}
		})();
	}, [dispatch, notifyError]);

	return {
		isLoading,
		existingContacts,
		isOpenForm,
		isAddMode,
		onClickForm,
		selContId,
		selUserId,
		handleMode,
		userGroups,
	};
}

export default useUsers;
